module.exports = __webpack_public_path__ + "img/028.143b792b.png";